import {Grid, withStyles, withTheme, Button} from "@material-ui/core";
import * as PropTypes from "prop-types";
import style from "./styles";
import React, {useState} from "react";
import {withFb} from '../../contexts/FbProvider';
import Popper from '@material-ui/core/Popper';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import {IconExpandir as ArrowDropDownIcon} from '../icons/MateraIcons';

const DropButtonBuilder = (props) => {
    const [anchorRef, setAnchorRef] = useState();
    const {fieldSchema: schema, classes, /*form*/} = props;

    return <ClickAwayListener onClickAway={() => setAnchorRef(false)}>
        <Grid item {...schema.props} {...(schema.sizes ?? {})} className={classes.dropButtonContainer}>
            {
                schema.default &&
                <ButtonGroup variant="contained" fullWidth aria-label="split button" size={'small'}
                             className={classes.dropButtonGroup}>
                    <Button variant={'outlined'} onClick={schema.default.onClick}>{schema.default.label}</Button>
                    <Button
                        variant={'outlined'}
                        size="small"
                        aria-controls={Boolean(anchorRef) ? 'split-button-menu' : undefined}
                        aria-expanded={Boolean(anchorRef) ? 'true' : undefined}
                        aria-label="select merge strategy"
                        aria-haspopup="menu"
                        onClick={e => setAnchorRef(e.currentTarget)}
                        className={classes.dropButton}
                    >
                        <ArrowDropDownIcon/>
                    </Button>
                </ButtonGroup>
            }
            <Popper open={Boolean(anchorRef)}
                    anchorEl={anchorRef}
                    transition
                    disablePortal
                    placement="bottom-end"
                    className={classes.dropButtonPaper}>
                {({TransitionProps, placement}) => {
                    return (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: 'right top',
                            }}
                        >
                            <Paper>
                                <MenuList id="split-button-menu">
                                    {schema.options.map((option, index) => (
                                        <MenuItem
                                            key={index}
                                            onClick={(e) => {
                                                option.onClick(e);
                                                setAnchorRef(false);
                                            }}
                                        >
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </Paper>
                        </Grow>
                    )
                }}
            </Popper>
        </Grid>
    </ClickAwayListener>;
};

DropButtonBuilder.propTypes = {
    classes: PropTypes.any,
    data: PropTypes.any
};

export default withTheme(withStyles(style)(withFb(DropButtonBuilder)));
